import adapterDataPagination from '../../../Domain/Adapters/pagination.adapter';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { createReducer, on } from '@ngrx/store';
import {
	deleteClient,
	deleteClientError,
	deleteClientSuccess,
	deleteModuleOneClient,
	deleteModuleOneClientError,
	deleteModuleOneClientSuccess,
	getClient,
	getClientError,
	getClientResourcesSearchModuleSuccess,
	getClientSuccess,
	getModuleOneClient,
	getModuleOneClientError,
	getModuleOneClientSuccess,
	getResourcesModuleClient,
	getResourcesModuleClientSuccess,
	postClient,
	postClientError,
	postClientSuccess,
	postModuleClient,
	postModuleClientError,
	postModuleClientSuccess,
	searchClient,
	searchClientError,
	searchClientSuccess,
	updateClient,
	updateClientError,
	updateClientSuccess,
	updateModuleOneClient,
	updateModuleOneClientError,
	updateModuleOneClientSuccess,
} from './clients.action';
import { initialStateModule } from './clients.state';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';

export const reducerClient = createReducer(
	initialStateModule,
	on(getClientSuccess, searchClientSuccess, (state, { client }) => ({
		...state,
		clients: client,
		loading: false,
		loadingModule: false,
		error: null,
	})),
	on(getModuleOneClientSuccess, (state, { module, client }) => {
		return {
			...state,
			loading: false,
			loadingModule: false,
			clients: state.clients.map((data) => {
				return data.sk === client.sk && data.pk === client.pk ? { ...data, module } : data;
			}),
			error: null,
		};
	}),
	on(getResourcesModuleClientSuccess, (state, { pagination, resource, pk, pkClient, skClient }) => {
		return {
			...state,
			loading: false,
			loadingModule: false,
			clients: state.clients.map((data) => {
				return data.pk === pkClient && data.sk === skClient
					? {
							...data,
							module: data.module.map((mod) =>
								mod.modulePk === pk
									? {
											...mod,
											dataResources: {
												...mod.dataResources,
												paginationIni: pagination,
												resource,
												pagination: adapterDataPagination(
													pagination
														? pagination
														: (state.clients
																.find((cli) => cli.pk === pkClient && cli.sk === skClient)
																?.module.find((moPa) => moPa.modulePk === pk)?.dataResources
																.paginationIni as Pagination)
												),
											},
									  }
									: mod
							),
					  }
					: data;
			}),
			error: null,
		};
	}),
	on(
		getClientResourcesSearchModuleSuccess,
		(state, { resource, pagination, pk, pkClient, skClient }) => ({
			...state,
			loading: false,
			loadingModule: false,
			clients: state.clients.map((data) => {
				return data.pk === pkClient && data.sk === skClient
					? {
							...data,
							module: data.module.map((mod) =>
								mod.modulePk === pk
									? {
											...mod,
											dataResources: {
												resource,
												paginationIni: pagination,
												pagination: adapterDataPagination(
													pagination
														? pagination
														: (state.clients
																.find((cli) => cli.pk === pkClient && cli.sk === skClient)
																?.module.find((moPa) => moPa.modulePk === pk)?.dataResources
																.paginationIni as Pagination)
												),
											},
									  }
									: mod
							),
					  }
					: data;
			}),
			error: null,
		})
	),
	on(deleteModuleOneClientSuccess, (state, { module, client }) => {
		const dataClients: Client[] = [...state.clients];
		const clients = dataClients.map((clientSelect) => {
			if (clientSelect.sk === client.sk) {
				const dataModule = clientSelect.module.filter(
					(moduleElement) => moduleElement.custom_name_module !== module.custom_name_module
				);
				return {
					...clientSelect,
					loading: false,
					module: dataModule,
				};
			}
			return clientSelect;
		});
		return { ...state, loadingModule: false, loading: false, clients };
	}),
	on(postClientSuccess, (state, { client }) => ({
		...state,
		loadingModule: false,
		loading: false,
		clients: [client, ...state.clients],
		error: null,
	})),
	on(updateClientSuccess, (state, { client }) => ({
		...state,
		loading: false,
		loadingModule: false,
		clients: state.clients.map((data) => {
			return data.pk === client.pk ? client : data;
		}),
		error: null,
	})),
	on(deleteClientSuccess, (state, { client }) => {
		const item = [...state.clients];
		let clients: Client[] = [];
		item.forEach((clientSelected) => {
			if (clientSelected.sk != client.sk) {
				clients.push(clientSelected);
			}
		});
		return {
			...state,
			clients,
			loading: false,
			loadingModule: false,
			error: null,
		};
	}),
	on(postModuleClientSuccess, (state, { client, module }) => {
		const item: Client[] = [...state.clients];
		const clients = item.map((clientItem) => {
			if (clientItem.pk === client.pk && clientItem.sk === client.sk) {
				return {
					...clientItem,
					module: [module, ...clientItem.module],
				};
			} else {
				return clientItem;
			}
		});
		return {
			...state,
			loading: false,
			loadingModule: false,
			clients: clients,
			error: null,
		};
	}),
	on(updateModuleOneClientSuccess, (state, { client, module }) => ({
		...state,
		loading: false,
		loadingModule: false,
		clients: state.clients.map((data) => {
			if (data.sk === client.sk && data.pk === client.pk) {
				return {
					...data,
					module: data.module.map((itemModule) => {
						return itemModule.moduleSk === module.moduleSk &&
							itemModule.modulePk === module.modulePk
							? module
							: itemModule;
					}),
				};
			} else {
				return data;
			}
		}),
		error: null,
	})),
	on(
		postClientError,
		postModuleClientError,
		getClientError,
		getModuleOneClientError,
		updateModuleOneClientError,
		updateClientError,
		deleteModuleOneClientError,
		deleteClientError,
		searchClientError,
		(state, action) => ({
			...state,
			loading: false,
			loadingModule: false,
			error: action.error,
		})
	),
	on(
		getClient,
		getModuleOneClient,
		postClient,
		postModuleClient,
		deleteModuleOneClient,
		deleteClient,
		updateClient,
		searchClient,
		(state, action) => ({
			...state,
			loading: true,
		})
	),
	on(updateModuleOneClient, getResourcesModuleClient, (state, action) => ({
		...state,
		loadingModule: true,
	}))
);
